import React from 'react';
import { Accordion, Card, Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

function CollapseCard() {
  const { t } = useTranslation('common');

  return (
    <div className="collapse-card">
      <Accordion defaultActiveKey="0">
        <Card className="mb-3">
          <Card.Header>
            {t('COLLAPSE_CARD.INVITE_SUPPLIER')}
            <Accordion.Toggle className="btn-toggle" as={Button} variant="link" eventKey="0">
              <i className="icon-add" />
            </Accordion.Toggle>
          </Card.Header>
          <Accordion.Collapse eventKey="0">
            <Card.Body>{t('COLLAPSE_CARD.HELLO_BODY_1')}</Card.Body>
          </Accordion.Collapse>
        </Card>
        <Card>
          <Card.Header>
            {t('COLLAPSE_CARD.POST_REQUIREMENT')}
            <Accordion.Toggle className="btn-toggle" as={Button} variant="link" eventKey="1">
              <i className="icon-add" />
            </Accordion.Toggle>
          </Card.Header>
          <Accordion.Collapse eventKey="1">
            <Card.Body>{t('COLLAPSE_CARD.HELLO_BODY_2')}</Card.Body>
          </Accordion.Collapse>
        </Card>
      </Accordion>
    </div>
  );
}

export default CollapseCard;
